module.exports = __webpack_public_path__ + "img/client.b5bf4e55.png";